import React from 'react';
import { useUnit } from 'effector-react';
import ResidentialComplexCard from './ResidentialComplexCard';
import EmptyState from '../EmptyState';
import { $isSettlementTenant } from '../../store';
import { getObjectKindLabels, normalizeComplexKind } from '../../utils/complexKind';
import './ResidentialComplexList.css';

export default function ResidentialComplexList({
  items = [],
  loading = false,
  onReload,
  onCheckItem,
  checkedIds = new Set(),
  onItemClick,
  emptyActionLabel,
  onEmptyAction,
}) {
  const isSettlementTenant = useUnit($isSettlementTenant);
  const labels = getObjectKindLabels(isSettlementTenant);
  const tenantKind = normalizeComplexKind(isSettlementTenant ? 'settlement' : 'mdu');

  if (loading) {
    return (
      <div className="rc-list">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="rc-card rc-card--skeleton">
            <div className="rc-skeleton__block rc-skeleton__title" />
            <div className="rc-skeleton__block rc-skeleton__line" />
            <div className="rc-skeleton__block rc-skeleton__line short" />
            <div className="rc-skeleton__row">
              <div className="rc-skeleton__chip" />
              <div className="rc-skeleton__chip" />
              <div className="rc-skeleton__chip" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!items.length) {
    return (
      <EmptyState
        icon="complex"
        title={labels.complexEmpty}
        subtitle="Добавьте первый объект"
        actionLabel={emptyActionLabel || labels.addComplex}
        onAction={onEmptyAction}
        secondaryLabel="Обновить"
        onSecondary={onReload}
      />
    );
  }

  return (
    <div className="rc-list">
      {items.map((rc) => (
        <ResidentialComplexCard
          key={rc.id || rc.name}
          id={rc.id}
          name={rc.name}
          address={rc.address}
          addresses={rc.addresses}
          counters={rc.counters}
          incidents={rc.incidents}
          complexKind={tenantKind === 'settlement' ? 'settlement' : (rc.complex_kind || 'mdu')}
          checked={checkedIds.has(rc.id)}
          onCheck={(v) => onCheckItem?.(rc.id, v)}
          onClick={onItemClick ? () => onItemClick(rc.id) : undefined}
        />
      ))}
    </div>
  );
}
